// vendor
import './vendor/bootstrap-custom';

// dev
import showScreenInfo from './dev/screen-info';
//import showDesignReference from './dev/design-reference';

// utils
import LoadListener from './utils/load-listener';

// acf
import getFlexibleContentLayoutLoader from './app/acf/flexible-content/layout-loader';

// site
import setupMainMenu from './app/site/main-menu';

// app
import {getAppConfigVar} from './app/config';

// components
import './app/components/video';
import addWCAGEnhancements from './app/components/wcag';
import setupContainerAligned from './app/components/container-aligned';
import setupSiteAnnouncement from './app/components/site-announcement';
import setupSlideshows from './app/components/slideshow';
import setupImageGalleries from './app/sections/image-gallery';
import setupVideoModals from './app/components/video-modal';
import setupWeeklyWateringAdviceSubscribe from './app/components/watering-advice-subscribe';
import setupShowSubscriberIds from './app/components/show-subscriber-id';
import setupSubscriberPreferencesForm from './app/components/subscriber-preferences-form';
import setupHeaderSearch from './app/site/header-search';
import setupNewsStoryGalleries from './app/sections/news-story-gallery';
import setupTrackedEvents from './app/components/track-events';


/**
 *
 */
new LoadListener( {
	fonts: {
		families: ['Inter'],
		loaded:   () => null
	},
	dom:   () =>
		   {
			   const devMode = getAppConfigVar( 'devMode' );

			   addWCAGEnhancements();
			   setupSiteAnnouncement();
			   setupContainerAligned();
			   setupMainMenu();
			   setupSlideshows();
			   setupImageGalleries();
			   setupVideoModals();
			   setupWeeklyWateringAdviceSubscribe();
			   setupShowSubscriberIds();
			   setupSubscriberPreferencesForm();
			   setupHeaderSearch();
			   setupNewsStoryGalleries();
			   setupTrackedEvents();
			   getFlexibleContentLayoutLoader().loadAll();

			   if (devMode) {
				   showScreenInfo();
			   }
		   },
	page:  () => null,
} );